import { defineStore } from 'pinia';
import { ref } from 'vue';
import { http } from '@/plugins/axios';
import { sleep } from '@/core/lib';

export const useAuthStore = defineStore('auth', () => {
  let tokenIsValid = false;
  const tokenTimeout = ref<number>(0);
  const initialized = ref<boolean>(false);
  const callbacks = {
    resolve: (value: any) => {},
    reject: (error: any) => {},
  };

  const logout = async (): Promise<void> => {
    await http.get('https://analyze.getwhy.io/api/auth/logout', {
      withCredentials: true,
    });
    await http.post('/logout');
    await sleep(300);
    tokenIsValid = false;
    window.location.reload();
  };

  const setAuthData = (expires_in: number) => {
    initialized.value = true;
    tokenIsValid = true;
    callbacks.resolve(true);

    clearTimeout(tokenTimeout.value);
    tokenTimeout.value = window.setTimeout(
      () => {
        tokenIsValid = false;
        checkingAuthentication = null;
      },
      Math.round(expires_in * 0.95),
    );
  };

  let checkingAuthentication: null | Promise<boolean> = null;
  const checkAuthCallbacks = {
    resolve: (value: any) => {},
    reject: (error: any) => {},
  };

  const isAuthenticated = async (): Promise<boolean> => {
    if (tokenIsValid) {
      return true;
    }

    if (checkingAuthentication !== null) {
      return checkingAuthentication;
    }

    checkingAuthentication = new Promise<boolean>(async (resolve, reject) => {
      checkAuthCallbacks.resolve = resolve;
      checkAuthCallbacks.reject = reject;
    });

    try {
      // this should trigger a refresh if the token is no longer valid
      await http.get<{ buildNumber: string }>('/ping');
      checkAuthCallbacks.resolve(true);
      return true;
    } catch (e) {
      tokenIsValid = false;
      checkAuthCallbacks.resolve(false);
    }

    return false;
  };

  return {
    initialized,
    isAuthenticated,
    setAuthData,
    logout,
  };
});
